import { Col, message } from "antd";
import { Icons } from "../assets/icons";
import PageHeader from "../components/ui/PageHeader";
import { ICON_SIZE } from "../repository/data.default";
import FooterQuoteCard from "../components/ui/FooterQuoteCard";
import SatageSubHeader from "../components/ui/SatageSubHeader";
import SectionTwo from "../components/ImplementationSections/SectionTwo";
import ViewReportCard from "../components/ui/ViewReportCard";

const footerText = (
  <p>
    Implementation translates planning into live operations: programs are
    assigned, communications sent, trainings scheduled and support measures
    activated. Monitoring due dates and completion keeps every initiative
    accountable so improvements compound through the cycle.
  </p>
);

const stepsList = (
  <>
    <li>a. Assign approved interventions or programs</li>
    <li>b. Create or assign company actions</li>
    <li>c. Schedule training / events</li>
    <li>d. Send communications and assign resources</li>
    <li>e. Monitor due dates and completion</li>
  </>
);

const overviewText = (
  <p>
    Welcome to the Implementation Step. This step turns the planning stage
    outputs into live rollout — interventions, communications, program
    assignments and support measures delivered to the right audience with
    clear due dates and ownership.
  </p>
);

const viewReportCardText = `The Implementation Progress Report rolls up every assigned program, action, training and communication for this cycle with their status and audience coverage.`;

function ImplementationPage() {
  return (
    <Col className="relative flex flex-auto flex-col overflow-hidden overflow-y-auto">
      <PageHeader
        stage={4}
        title={"IMPLEMENTATION"}
        icon={<Icons.RocketLaunchIcon width={ICON_SIZE} height={ICON_SIZE} />}
      />
      <SatageSubHeader overviewText={overviewText} stepsList={stepsList} />
      <ViewReportCard
        title="IMPLEMENTATION PROGRESS"
        text={viewReportCardText}
        btnName="view report"
        btnAction={() => message.info("This report is not yet available.")}
      />
      <SectionTwo />
      <FooterQuoteCard
        icon={<Icons.RocketLaunchIcon width={350} height={350} />}
        text={footerText}
      />
    </Col>
  );
}

export default ImplementationPage;
